import * as React from "react";
import { SVGProps } from "react";
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M27 16a11 11 0 1 0-12.719 10.866V19.18h-2.793V16h2.793v-2.423c0-2.757 1.642-4.28 4.155-4.28.825.011 1.648.083 2.462.215v2.707h-1.387a1.59 1.59 0 0 0-1.792 1.718V16h3.051l-.488 3.18h-2.563v7.686A11 11 0 0 0 27 16Z"
    />
  </svg>
);
export default SvgFacebook;
